import * as yup from 'yup';

import { i18n } from 'i18n';
import { IdCardAddValues } from '../types';

export const getValidationSchema = (): yup.SchemaOf<IdCardAddValues> =>
  yup.object({
    name: yup
      .string()
      .required(i18n.t('messages.idCards:cardNameRequired'))
      .max(250, i18n.t('maximumLengthExceeded', { count: 250 }))
      .trim(),
    frontImage: yup
      .object()
      .test(
        'frontImage',
        i18n.t('messages.idCards:frontImageRequired'),
        (value) => value.fakepath !== undefined
      ),
  });
